import ExpandableList from '@/ui/components/expandable-list'
import clsx from 'clsx'
import { FC } from 'react'
import { InfoItem } from '../../common/infoItem'

type TAssetInfoDomainProps = {
    asset: TAsset
}

const AssetInfoDomain: FC<TAssetInfoDomainProps> = ({ asset }) => {
    const { certificates, open_ports: openPorts } = asset
    const certs = certificates?.[0] || ({} as TAssetCertificates)

    const hasCertificates = Object?.keys(certs).length > 0
    const hasOpenPorts = !!openPorts?.length
    const hasData = hasCertificates || hasOpenPorts

    if (!hasData) {
        return null
    }

    return (
        <>
            {hasCertificates && (
                <InfoItem title="Certificates" className="certificates">
                    <>
                        {Object.keys(certs)?.map((cert) => {
                            const certNameSplit = cert.split('_')
                            const certName =
                                certNameSplit.length > 2
                                    ? `${certNameSplit[0]} ${certNameSplit[1]}.${certNameSplit[2]}`
                                    : certNameSplit.length > 1
                                      ? `${certNameSplit[0]} ${certNameSplit[1]}`
                                      : certNameSplit[0]

                            return (
                                certs[cert as keyof TAssetCertificates] && (
                                    <div key={cert} className="certificate">
                                        {certName}
                                    </div>
                                )
                            )
                        })}
                    </>
                </InfoItem>
            )}
            {hasOpenPorts && (
                <InfoItem title="Open ports" className="open-ports">
                    <ExpandableList
                        list={openPorts}
                        renderItem={({
                            port_number: portNumber,
                            transport_protocol: transportProtocol,
                        }) => (
                            <div key={portNumber} className={clsx(['port'])}>
                                {transportProtocol} {portNumber}
                            </div>
                        )}
                    />
                </InfoItem>
            )}
        </>
    )
}

export default AssetInfoDomain
